<template>
    <div class="cell-render-text-color">
        <span :style="{color:this.params.value.color, fontWeight:'600'}">{{ params.value.value }}</span>
    </div>
</template>

<script>
export default {}
</script>
